<template>
    <v-container fluid class="dataTable">
        <v-toolbar dense dark color="secondary" class="white--text">
            <v-spacer></v-spacer>
            <v-toolbar-title>
                Transacting Menu
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn dark icon left to="/administration/transacting"
                ><v-icon>mdi-arrow-left</v-icon></v-btn
            >
        </v-toolbar>
        <v-row cols="12" class="">
            <v-col cols="12" style="padding-bottom: 0px;">
                <v-combobox
                    label="Select Shift"
                    outlined
                    filled
                    dense
                    v-model="shift"
                    :items="textbox"
                    :item-text="'text'"
                    :item-value="'ShiftDetail'"
                    @change="loadShiftInfo()"
                ></v-combobox>
            </v-col>
            <!--Show Data and Bottoms-->
            <v-col cols="2" sm="6" lg="2" class="v-sizebox divs">
                <v-card tile>
                    <v-list flat>
                        <v-list-item-group
                            v-model="selectedItem"
                            color="primary"
                        >
                            <v-list-item
                                v-for="(item, i) in items"
                                :key="i"
                                @click="subMenu = item.action"
                            >
                                <v-list-item-icon>
                                    <v-icon v-text="item.icon"></v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title
                                        v-text="item.text"
                                    ></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-card>
            </v-col>
            <v-col cols="10" sm="6" lg="10" class="v-sizebox">
                <v-col cols="" v-if="subMenu == 1">
                    <v-row>
                        <v-col cols="2" sm="4" lg="2" class="chps divs">
                            ShiftDetail *
                            <v-chip class="divs" label value>
                                {{ ShiftDetail[0]['ShiftDetail'] }}
                            </v-chip>
                        </v-col>
                        <v-col cols="2" sm="4" lg="2" class="chps divs">
                            ShiftDate *
                            <v-chip class="divs" label value>
                                {{ ShiftDetail[0].ShiftDate }}
                            </v-chip>
                        </v-col>
                        <v-col cols="2" sm="4" lg="1" class="chps divs">
                            Shift *
                            <v-chip class="divs" label value>
                                {{ ShiftDetail[0].Shift }}
                            </v-chip>
                        </v-col>

                        <v-col cols="2" sm="4" lg="2" class="chps divs">
                            Truck *
                            <v-chip class="divs" label value>
                                {{ ShiftDetail[0].Truck }}
                            </v-chip>
                        </v-col>

                        <v-col cols="2" sm="4" lg="2" class="chps divs">
                            Trailer *
                            <v-chip class="divs" label value>
                                {{ ShiftDetail[0].Trailer }}
                            </v-chip>
                        </v-col>
                        <v-col cols="2" sm="4" lg="2" class="chps divs">
                            Yard *
                            <v-chip class="divs" label value>
                                {{ ShiftDetail[0].Yard }}
                            </v-chip>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="2" sm="4" lg="" class="chps divs">
                            Driver *
                            <v-chip class="divs" label value>
                                {{ ShiftDetail[0].Driver }}
                            </v-chip>
                        </v-col>
                        <v-col cols="2" sm="4" lg="3" class="chps divs">
                            ShiftStartTime *
                            <v-chip class="divs" label value>
                                {{ ShiftDetail[0].ShiftStartTime }}
                            </v-chip>
                        </v-col>
                        <v-col cols="2" sm="4" lg="3" class="chps divs">
                            ShiftEndTime *
                            <v-chip class="divs" label value>
                                {{ ShiftDetail[0].ShiftEndTime }}
                            </v-chip>
                        </v-col>
                    </v-row>
                </v-col>

                <v-col v-else-if="subMenu == 2">
                    <v-row cols="12">
                        <v-col cols="2" sm="4" lg="3" class="chps divs">
                            Total Revenue *
                            <v-chip class="divs" label value>
                                {{ totalRev }}
                            </v-chip>
                        </v-col>
                        <v-col cols="2" sm="4" lg="3" class="chps divs">
                            Total Payroll *
                            <v-chip class="divs" label value>
                                {{ totalPay }}
                            </v-chip>
                        </v-col>
                        <v-col cols="2" sm="4" lg="3" class="chps divs">
                            Total Extra Revenue *
                            <v-chip class="divs" label value>
                                {{ totalExtraRev }}
                            </v-chip>
                        </v-col>
                        <v-col cols="2" sm="4" lg="3" class="chps divs">
                            Total Extra Payroll *
                            <v-chip class="divs" label value>
                                {{ totalExtraPay }}
                            </v-chip>
                        </v-col>
                        <v-col cols="2" sm="4" lg="3" class="chps divs">
                            Net *
                            <v-chip class="divs" label value>
                                {{ net }}
                            </v-chip>
                        </v-col>
                        <v-col cols="2" sm="4" lg="3" class="chps divs">
                            Margin *
                            <v-chip class="divs" label value>
                                {{ margin }}
                            </v-chip>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col v-else>
                    <v-row class="divs">
                        <v-col
                            class="divs"
                            cols="2"
                            style="padding-top: 0px; margin-top: 0px"
                        >
                            <v-checkbox
                                label="No Rate"
                                v-model="shift.NoRate"
                            ></v-checkbox>
                            <v-checkbox
                                label="Short Load"
                                v-model="shift.ShortLoad"
                            ></v-checkbox>
                            <v-checkbox
                                label="Other"
                                v-model="shift.Other"
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="8">
                            <v-textarea
                                class="mt-4"
                                label="Comments"
                                outlined
                                dense
                                v-model="shift.AdmComments"
                            ></v-textarea
                        ></v-col>
                        <v-col cols="1" class="my-auto">
                            <v-btn color="success" @click="saveMore(shift)"
                                >Submit</v-btn
                            >
                        </v-col>
                    </v-row>
                </v-col>
            </v-col>
        </v-row>
        <v-row class="mb-2">
            <v-col>
                <v-btn
                    color="primary"
                    :disabled="btnRevenue"
                    block
                    black
                    @click="transactRev()"
                    >Transact Revenue</v-btn
                >
            </v-col>
            <v-col>
                <v-btn
                    color="primary"
                    :disabled="btnPayroll"
                    block
                    black
                    @click="transactPay()"
                    >Transact Payroll</v-btn
                >
            </v-col>
            <v-col>
                <v-btn color="primary" block black>Finalize</v-btn>
            </v-col>
            <v-col>
                <v-btn color="primary" block black>UnFinalize</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <!--Tables-->
            <v-col cols="12" style="padding-top: 0">
                <v-row>
                    <v-col cols="12" style="padding-top: 0px; margin: 0px">
                        <v-toolbar color="primary" dense dark
                            >Transact By Shift</v-toolbar
                        >
                        <v-data-table
                            :headers="orderHeaders"
                            :items="orders"
                            item-key="id"
                            search
                            class="elevation-2"
                            dense
                            height="250"
                            hide-default-footer
                            disable-sort
                            disable-pagination
                        >
                            <template v-slot:item.open="{ item }">
                                <v-icon
                                    persistent
                                    class="mx-3"
                                    color="primary"
                                    dark
                                    @click="openModalOrder(item)"
                                    >mdi-open-in-new</v-icon
                                >
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" style="padding-top: 0px; margin: 0px">
                        <v-toolbar color="primary" dense dark
                            >Revenue</v-toolbar
                        >
                        <v-data-table
                            :headers="transHeaders"
                            :items="revTrans"
                            item-key="id"
                            search
                            class="elevation-1 mt-1"
                            dense
                            height="200"
                            hide-default-footer
                            disable-pagination
                        >
                            <template v-slot:item.actions="{ item }">
                                <v-icon
                                    small
                                    class="mx-3"
                                    color="red"
                                    dark
                                    @click="deleteItem(item)"
                                    >mdi-delete-forever-outline</v-icon
                                >
                            </template>
                        </v-data-table>
                        <v-row justify="end">
                            <v-col cols="12">
                                Total Rev *
                                <v-chip class="divs" label value>
                                    {{ totalRev }}
                                </v-chip>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="6" style="padding-top: 0px; margin: 0px">
                        <v-toolbar color="primary" dense dark
                            >PayRoll</v-toolbar
                        >
                        <v-data-table
                            :headers="transPayHeaders"
                            :items="payTrans"
                            item-key="id"
                            search
                            class="elevation-1 mt-1"
                            dense
                            height="200"
                            hide-default-footer
                            disable-pagination
                        >
                            <template v-slot:item.actions="{ item }">
                                <v-icon
                                    small
                                    class="mx-3"
                                    color="red"
                                    dark
                                    @click="deleteItem(item)"
                                    >mdi-delete-forever-outline</v-icon
                                >
                            </template>
                        </v-data-table>
                        <v-row justify="end">
                            <v-col cols="12">
                                <v-btn
                                    class="mr-3"
                                    x-small
                                    @click="$store.state.posting.mod = true"
                                    >Calculate MOQ</v-btn
                                >
                                Total Payroll *
                                <v-chip class="divs" label value>
                                    {{ totalPay }}
                                </v-chip>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" style="padding-top: 0px; margin: 0px">
                        <v-toolbar color="primary" dense dark
                            >Extra Revenue</v-toolbar
                        >
                        <v-data-table
                            :headers="transHeaders"
                            :items="extraRevTrans"
                            item-key="id"
                            search
                            class="elevation-1 mt-1"
                            dense
                            height="200"
                            hide-default-footer
                            disable-sort
                            disable-pagination
                        >
                            <template v-slot:item.actions="{ item }">
                                <v-icon
                                    small
                                    class="mx-3"
                                    color="red"
                                    dark
                                    @click="deleteItem(item)"
                                    >mdi-delete-forever-outline</v-icon
                                >
                            </template>
                        </v-data-table>
                        <v-row justify="end">
                            <v-col cols="12">
                                Total Extra Revenue *
                                <v-chip class="divs" label value>
                                    {{ totalExtraRev }}
                                </v-chip>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="6" style="padding-top: 0px; margin: 0px">
                        <v-toolbar color="primary" dense text-center dark
                            >Extra Payroll</v-toolbar
                        >
                        <v-data-table
                            :headers="transPayHeaders"
                            :items="extraPayTrans"
                            item-key="id"
                            search
                            class="elevation-1 mt-1"
                            dense
                            height="200"
                            hide-default-footer
                            disable-sort
                            disable-pagination
                        >
                            <template v-slot:item.actions="{ item }">
                                <v-icon
                                    small
                                    class="mx-3"
                                    color="red"
                                    dark
                                    @click="deleteItem(item)"
                                    >mdi-delete-forever-outline</v-icon
                                >
                            </template>
                        </v-data-table>
                        <v-row justify="end">
                            <v-col cols="12">
                                Total Extra Payroll *
                                <v-chip class="divs" label value>
                                    {{ totalExtraPay }}
                                </v-chip>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-dialog
            v-model="$store.state.posting.dialog"
            transition="dialog-bottom-transition"
            overlay-color="accent"
            width="1500"
        >
            <OrderData v-if="$store.state.posting.dialog" />
        </v-dialog>

        <CalculateMoq
            :Add="shift.ShiftDetail"
            v-if="$store.state.posting.mod"
        />
    </v-container>
</template>

<script>
import axios from 'axios';
import CalculateMoq from './../Modals/Administration/Transacting/CalculateMoq.vue';
import OrderData from './../Modals/Administration/OrderData.vue';

export default {
    components: {
        OrderData,
        CalculateMoq
    },

    data: function() {
        return {
            items: [
                {
                    text: 'Details',
                    icon: 'mdi-card-account-details-outline',
                    action: 1
                },
                { text: 'Totals', icon: 'mdi-star-circle', action: 2 },
                { text: 'Comments', icon: 'mdi-dots-horizontal', action: 3 }
            ],
            btnPayroll: true,
            selectedItem: '',
            btnRevenue: true,
            color: 'purple',
            shifts: [],
            subMenu: 1,
            shift: [],
            orders: [],
            revTrans: [],
            payTrans: [],
            textbox: [],
            extraRevTrans: [],
            extraPayTrans: [],
            ShiftDetail: {
                '0': {
                    ShiftDetail: '',
                    Yard: '',
                    Trailer: '',
                    Driver: '',
                    Truck: '',
                    ShiftStartTime: '',

                    ShiftEndsTime: '',
                    Shift: '',
                    ShiftDate: ''
                }
            },
            orderHeaders: [
                { text: 'Action', value: 'open', width: '1%' },
                { text: 'L1', value: 'LoadNum', width: '1%' },
                { text: 'L2', value: 'LoadNumOrd', width: '1%' },
                { text: 'Order', value: 'OrderID', width: '5%' },
                { text: 'BOL', value: 'BOL', width: '5%' },
                { text: 'Customer', value: 'Customer', width: '25%' },
                { text: 'Terminal', value: 'Terminal', width: '15%' },
                { text: 'Station', value: 'Station', width: '20%' },
                {
                    text: 'Preload Order#',
                    value: 'PreloadOrderID',
                    width: '5%'
                }
            ],
            transHeaders: [
                { text: 'Order', value: 'OrderNumber', width: '10%' },
                {
                    text: 'Transaction Type',
                    value: 'TransactionName',
                    width: '20%'
                },
                { text: 'Qty', value: 'Quantity', width: '10%' },
                { text: 'Rate', value: 'Rate', width: '10%' },
                { text: 'Amount', value: 'Amount', width: '10%' },
                { text: 'InvId', value: 'InvId', width: '5%' },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false,
                    width: '10%'
                }
            ],
            transPayHeaders: [
                { text: 'Order', value: 'OrderNumber', width: '10%' },
                {
                    text: 'Transaction Type',
                    value: 'TransactionName',
                    width: '20%'
                },
                { text: 'Qty', value: 'Quantity', width: '10%' },
                { text: 'Rate', value: 'Rate', width: '10%' },
                { text: 'Amount', value: 'Amount', width: '10%' },
                { text: 'PayId', value: 'PayId', width: '5%' },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false,
                    width: '10%'
                }
            ]
        };
    },

    mounted() {
        this.loadShifts();
    },
    watch: {
        '$store.state.transacting.watch': function() {
            if (this.$store.state.transacting.watch == true) {
                this.loadShiftInfo();
            } else {
                console.log('Hola');
            }
        }
    },
    computed: {
        totalRev: function() {
            var list = this.revTrans;
            var sum = 0;
            for (var rev in list) {
                sum += list[rev].Amount;
            }
            sum = Math.round((sum + Number.EPSILON) * 100) / 100;
            return sum;
        },
        totalExtraRev: function() {
            var list = this.extraRevTrans;
            var sum = 0;
            for (var rev in list) {
                sum += list[rev].Amount;
            }
            sum = Math.round((sum + Number.EPSILON) * 100) / 100;
            return sum;
        },
        totalPay: function() {
            var list = this.payTrans;
            var sum = 0;
            for (var rev in list) {
                sum += list[rev].Amount;
            }
            sum = Math.round((sum + Number.EPSILON) * 100) / 100;
            return sum;
        },
        totalExtraPay: function() {
            var list = this.extraPayTrans;
            var sum = 0;
            for (var rev in list) {
                sum += list[rev].Amount;
            }
            sum = Math.round((sum + Number.EPSILON) * 100) / 100;
            return sum;
        },
        net: function() {
            var net =
                this.totalRev +
                this.totalExtraRev +
                (this.totalPay + this.totalExtraPay);
            return Math.round((net + Number.EPSILON) * 100) / 100;
        },
        margin: function() {
            var margin = this.net / (this.totalRev + this.totalExtraRev);
            return Math.round((margin + Number.EPSILON) * 100) / 100;
        }
    },

    methods: {
        loadShifts: function() {
            this.$store.state.isLoading = true;
            axios
                .get(
                    'shift-detail/dates/transact/' +
                        0 +
                        '/' +
                        this.$store.state.transacting.start_date +
                        '/' +
                        this.$store.state.transacting.end_date,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    var box = {};
                    this.shifts = response.data.data;
                    for (let i = 0; i < this.shifts.length; i++) {
                        box = {
                            ShiftDetail: this.shifts[i].ShiftDetail,
                            AdmComments: this.shifts[i].AdmComments,
                            NoRate: this.shifts[i].NoRate,
                            ShortLoad: this.shifts[i].ShortLoad,
                            Other: this.shifts[i].Other,
                            text:
                                this.shifts[i].ShiftDetail +
                                ' - ' +
                                this.shifts[i].Driver +
                                ' - ' +
                                this.shifts[i].Truck +
                                ' - ' +
                                this.shifts[i].Trailer
                        };
                        this.textbox.push(box);
                    }
                    console.log(this.textbox);
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadShiftInfo: function() {
            console.log(this.shift);
            this.$store.state.isLoading = true;
            this.loadOrders();
            this.loadRev();
            this.loadShift();
            this.loadExtraRev();
            this.loadPay();
            this.loadExtraPay();
            this.btnRevenue = true;
            this.btnPayroll = true;
            this.$store.state.transacting.watch = false;
        },
        loadShift: async function() {
            try {
                let response = await axios.get(
                    'shift-detail/resource/' + this.shift.ShiftDetail,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                );
                this.ShiftDetail = response.data;
                console.log(this.ShiftDetail);
            } catch (error) {
                console.log(error);
            }
        },
        loadOrders: function() {
            console.log('loadOrders');
            axios
                .get('order/shift/' + this.shift.ShiftDetail, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.orders = response.data;
                    console.log(this.orders);
                    if (this.orders.length > 0) {
                        this.btnRevenue = false;
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadRev: function() {
            axios
                .get('transaction/revenue/' + this.shift.ShiftDetail, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.revTrans = response.data.data;

                    this.btnPayroll = false;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadExtraRev: function() {
            axios
                .get('transaction/extra-revenue/' + this.shift.ShiftDetail, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.extraRevTrans = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadPay: function() {
            axios
                .get('transaction/payroll/' + this.shift.ShiftDetail, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.payTrans = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadExtraPay: function() {
            axios
                .get('transaction/extra-payroll/' + this.shift.ShiftDetail, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.extraPayTrans = response.data.data;

                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        transactRev: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .post(
                    'transaction/transact-rev/' + this.shift.ShiftDetail,
                    '',
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    console.log(response.data);
                    this.loadRev();
                    this.loadExtraRev();
                    this.btnPayroll = false;

                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        transactPay: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .post(
                    'transaction/transact-pay/' + this.shift.ShiftDetail,
                    '',
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    console.log(response.data);
                    this.loadPay();
                    this.loadExtraPay();
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        deleteItem: function(item) {
            this.$store.state.isLoading = true;
            const index = item.TranId;
            var r = confirm('Are you sure you want to delete?');
            var str = this.$store;
            if (r) {
                axios
                    .delete('transaction/' + index, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    // eslint-disable-next-line no-unused-vars
                    .then(response => {
                        console.log(response);
                        this.loadShiftInfo();
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
                this.$store.state.isLoading = false;
            } else {
                confirm('Canceled');
            }
        },
        openModalOrder: function(item) {
            this.$store.state.orderInfo.orderId = item.OrderID;
            console.log(item);
            this.$store.state.posting.dialog = true;
        },
        saveMore: function(itm) {
            console.log(itm);
            var parms = {
                AdmComments: itm.AdmComments,
                'No Rate': itm.NoRate,

                'Short Load': itm.ShortLoad,
                Other: itm.Other
            };
            console.log(parms);
            axios
                .put('shift-detail/' + itm.ShiftDetail, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response);
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'saved successfully'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    }
};
</script>
<style>
@import '~vue-context/dist/css/vue-context.css';
div.divs {
    margin-top: 0px;
    margin-bottom: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
}
.v-input {
    font-size: 14.5px;
}
div.v-sizebox {
    padding: 5px;
    margin: 0px;
}
.v-sizebox > div {
    padding: 0px;
    margin: 0px;
}
.v-sizebox > div > div {
    padding: 0px;
    margin: 0px;
}
.v-sizebox > div > div > div {
    padding: 0px;
    margin: 4px;
}

div.chps {
    float: left;
}
.chps > span {
    width: 100%;
}
div.divs {
    margin-top: 0px;
    margin-bottom: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
}
</style>
